import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getQuestions,
  getQuizSectionIndex,
  getQuizSection,
  getQuizSectionQuestionObjects,
} from '../selectors';
import '../styles/QuizSection.css';

const QuizQuestions = ({
  questions,
  quizSection: { title },
  quizSectionQuestionObjects,
  quizSectionIndex,
}) => (
  <div className="QuizSection mw-100 mw7-ns center">
    {/* TODO Move the header into the App header? */}
    <div className="QuizSection-header fixed h3 w-100 flex items-center bb b--light-gray pa3 bg-white bg-white">
      <div className="flex items-center justify-between mw-100 mw7-ns w-100 center">
        <div className="pl3">
          <h1 className="f5 lh-solid">Review</h1>
          <span className="f7 light-silver">{title}</span>
        </div>
        <Link to="/quiz" className="pr2">
          <i className="material-icons">close</i>
        </Link>

      </div>
    </div>
    <ul className="QuizSection-questions list">

      <div>{console.log(questions)}</div>

    </ul>
  </div>
);

function mapStateToProps(state, ownProps) {
  return {
    questions: getQuestions(state, ownProps),
    quizSectionIndex: getQuizSectionIndex(state, ownProps),
    quizSection: getQuizSection(state, ownProps),
    quizSectionQuestionObjects: getQuizSectionQuestionObjects(state, ownProps),
  };
}

QuizQuestions.propTypes = {
  quizSection: PropTypes.shape({
    title: PropTypes.string.isRequired,
    questions: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  quizSectionQuestionObjects: PropTypes.objectOf(
    PropTypes.shape({

    }).isRequired,
  ).isRequired,
};

export default connect(mapStateToProps)(QuizQuestions);



// WEBPACK FOOTER //
// ./src/components/QuizQuestions.js